import styled from "styled-components";
import cx from "classnames";

export const Container = styled.div.attrs({
  className: cx("container", "mx-auto", "px-m"),
})``;